import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs/operators';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-data-type-filter',
  templateUrl: './data-type-filter.component.html',
  styleUrls: ['./data-type-filter.component.scss'],
  imports: [ReactiveFormsModule, FormsModule],
})
export class DataTypeFilterComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private translate = inject(TranslateService);

  selectedDataType: 'default' | 'gps' = 'default';
  isDetailPage = false;
  mapId: string | null = null;

  labels = {
    title: '',
    default: '',
    gps: '',
  };

  constructor() {
    this.initLabels();
  }

  ngOnInit(): void {
    // ルートの変更を監視
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateComponentState();
      });

    // 初期状態を設定
    this.updateComponentState();
  }

  private initLabels(): void {
    this.translate
      .get([
        'dataTypeFilter.title',
        'dataTypeFilter.all',
        'dataTypeFilter.inMap',
      ])
      .subscribe((translations) => {
        this.labels.title = translations['dataTypeFilter.title'];
        this.labels.default = translations['dataTypeFilter.all'];
        this.labels.gps = translations['dataTypeFilter.inMap'];
      });
  }

  private updateComponentState(): void {
    const url = this.router.url;
    // 詳細ページかどうかをチェック
    this.isDetailPage = url.includes('/details/');

    if (this.isDetailPage) {
      // URLからマップIDを取得（クエリパラメータを除外）
      const urlWithoutQuery = url.split('?')[0];
      const segments = urlWithoutQuery.split('/');
      const detailsIndex = segments.findIndex(
        (segment) => segment === 'details',
      );

      if (detailsIndex >= 0 && segments.length > detailsIndex + 1) {
        // クエリパラメータやフラグメントを除去してマップIDを取得
        this.mapId = segments[detailsIndex + 1].split('#')[0];
      }

      // GPS利用者ページかどうかをチェック
      this.selectedDataType =
        urlWithoutQuery.endsWith('/gps') || urlWithoutQuery.includes('/gps/')
          ? 'gps'
          : 'default';
    } else {
      this.selectedDataType = 'default';
      this.mapId = null;
    }
  }

  onDataTypeChange(dataType: 'default' | 'gps'): void {
    if (!this.isDetailPage || !this.mapId) {
      return;
    }

    let targetUrl: string;
    // Get the current query parameters
    const queryParams = { ...this.route.snapshot.queryParams };

    if (dataType === 'default') {
      targetUrl = `/details/${this.mapId}`;
    } else {
      targetUrl = `/details/${this.mapId}/gps`;
    }

    // Angular's navigate method handles URL encoding automatically when using the queryParams option
    this.router.navigate([targetUrl], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
